import { createFileRoute } from "@tanstack/react-router";
import DeviceIdentified from "@/features/assessments/pages/device-identified/DeviceIdentified";

export const Route = createFileRoute("/$locale/$partner/_device/device-identified")({
	component: DeviceIdentified,
});
